import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const BidsOverviewSupplierDetailsModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=YROQqMI7nN4&ab_channel=apadua" />
);

export default BidsOverviewSupplierDetailsModal;
